import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import type { LimitationDefinition } from "src/shared/api-types/limitations";

import ChipBox, { ChipBoxItem } from "src/components/ChipBox";

import { getLimitationPreviewValues, getOptionDisplayValue } from "../limitationDisplay";

interface LimitationPreviewChipsProps {
  definition: LimitationDefinition;
}

const LimitationPreviewChips = ({ definition }: LimitationPreviewChipsProps) => {
  const { t } = useTranslation();
  const activeOptions = definition.options.filter((option) => !option.archived);

  if (activeOptions.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
        }}
      >
        {t("limitations.no_values")}
      </Typography>
    );
  }

  const previewValues = getLimitationPreviewValues(
    definition.type,
    activeOptions.map((option) => option.value),
    t,
  );
  const chips: ChipBoxItem[] =
    definition.type === "boolean"
      ? previewValues.map((value) => ({ id: value, label: value }))
      : activeOptions.map((option) => ({ id: option.id, label: getOptionDisplayValue(definition, option, t) }));

  return <ChipBox items={chips} color="default" align="center" />;
};

export default LimitationPreviewChips;
